// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixData from 'wix-data';
import wixLocation from 'wix-location';

$w.onReady(function () {

	$w('#input10').onKeyPress((e)=>{
		if (e.key === 'Enter') {
			updateResults(e.target.value)
		}
	})

	let query = wixLocation.query.q;
	if (!query || query === "") return
	updateResults(query)
});

async function updateResults (query) {
	let results = [];
	console.log(query)
	await $w('#dataset1').setFilter(wixData.filter().contains('title', query).or(wixData.filter().contains('text', query)));
	results.push(...(await $w('#dataset1').getItems(0,$w('#dataset1').getTotalCount())).items.map(i=>({_id: i._id,title: i.title, text: i.text, url: i['link-infobasecontent-title-2']})))
	await $w('#dataset2').setFilter(wixData.filter().contains('title', query).or(wixData.filter().contains('text', query)));
	results.push(...(await $w('#dataset2').getItems(0,$w('#dataset2').getTotalCount())).items.map(i=>({_id: i._id,title: i.title, text: i.text, url: i['link-suppliers-title']})));
	await $w('#dataset3').setFilter(wixData.filter().contains('title', query).or(wixData.filter().contains('fullText', query)));
	results.push(...(await $w('#dataset3').getItems(0,$w('#dataset3').getTotalCount())).items.map(i=>({_id: i._id,title: i.title, text: i.shortText || i.fullText, url: i['link-tools-title']})));
	await $w('#dataset4').setFilter(wixData.filter().contains('title', query).or(wixData.filter().contains('plainContent', query)));
	results.push(...(await $w('#dataset4').getItems(0,$w('#dataset4').getTotalCount())).items.map(i=>({_id: i._id,title: i.title, text: i.plainContent, url: i.postPageUrl})));

	// .items.map(i=>({_id: i._id,title: i.title, text: i.text, url: i['link-infobasecontent-title-2']}))
	// results.push(...(await $w('#dataset2').getItems(0,$w('#dataset2').getTotalCount())).items.map(i=>({_id: i._id,title: i.title, text: i.text, url: i['link-suppliers-title']})));
	// results.push(...(await $w('#dataset3').getItems(0,$w('#dataset3').getTotalCount())).items.map(i=>({_id: i._id,title: i.title, text: i.shortText || i.fullText, url: i['link-tools-title']})));
	// results.push(...(await $w('#dataset4').getItems(0,$w('#dataset4').getTotalCount())).items.map(i=>({_id: i._id,title: i.title, text: i.plainContent, url: i.postPageUrl})));
	//console.log(results)
	if (results.length === 0) {
		$w('#text4').expand()
	} else {
		$w('#repeater1').data = results;
		$w('#repeater1').expand()
	}
}

export function repeater1_itemReady($item, itemData, index) {
	$item('#text1').text = itemData.title;
	$item('#text1').onClick(()=>{
		wixLocation.to(itemData.url)
	})
	if (!itemData.text) {
		$item('#text3').collapse()
	} else {
		$item('#text3').text = trimText(itemData.text)
	}
	$item('#button4').link = itemData.url;
}

function trimText (text) {
	if (text.length > 300) {
		let trimmed = text.substring(0,300);
		let lastSpace = trimmed.lastIndexOf(' ');
		return trimmed.substring(0,lastSpace) + "...";
	}
	return text
}